var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BSkeleton } from "bootstrap-vue";
import { ref } from "vue";
import { GalaxyApi } from "@/api";
import { useMarkdown } from "@/composables/markdown";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "./LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GalaxyWizard',
    props: {
        context: { default: "username" },
        jobId: null,
        query: null,
        view: { default: "error" }
    },
    setup(__props) {
        const props = __props;
        library.add(faThumbsUp, faThumbsDown);
        const query = ref(props.query);
        const queryResponse = ref("");
        const errorMessage = ref("");
        const busy = ref(false);
        const feedback = ref(null);
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true, removeNewlinesAfterList: true });
        /** On submit, query the server and put response in display box **/
        function submitQuery() {
            return __awaiter(this, void 0, void 0, function* () {
                busy.value = true;
                if (query.value === "") {
                    errorMessage.value = "There is no context to provide a response.";
                    busy.value = false;
                    return;
                }
                /**
                 * Note: We are using a POST request here, which at the backend checks if a response exists
                 * for the given job_id and returns it if it does. If it doesn't, it will create a new response.
                 * Curious whether this is better done by using a separate GET and then a POST?
                 * TODO: Remove this comment after discussion.
                 */
                const { data, error } = yield GalaxyApi().POST("/api/chat", {
                    params: {
                        query: { job_id: props.jobId },
                    },
                    body: {
                        query: query.value,
                        context: props.context,
                    },
                });
                if (error) {
                    errorMessage.value = errorMessageAsString(error, "Failed to get response from the server.");
                }
                else {
                    queryResponse.value = data;
                }
                busy.value = false;
            });
        }
        /** Send feedback to the server **/
        function sendFeedback(value) {
            return __awaiter(this, void 0, void 0, function* () {
                feedback.value = value;
                // up is 1 and down is 0
                const feedbackValue = value === "up" ? 1 : 0;
                const { error } = yield GalaxyApi().PUT("/api/chat/{job_id}/feedback", {
                    params: {
                        path: { job_id: props.jobId },
                        query: { feedback: feedbackValue },
                    },
                });
                if (error) {
                    errorMessage.value = errorMessageAsString(error, "Failed to send feedback to the server.");
                }
            });
        }
        return { __sfc: true, props, query, queryResponse, errorMessage, busy, feedback, renderMarkdown, submitQuery, sendFeedback, faThumbsDown, faThumbsUp, FontAwesomeIcon, BAlert, BButton, BSkeleton, LoadingSpan };
    }
});
